import './scroll-lock.scss';

class ScrollLock {
    constructor () {
        this.scrollPosition = 0;
        this.isLocked = false;
    }

    disableScroll () {
        if (this.isLocked) return;

        this.scrollbarWidth = this.getScrollbarWidth();
        const body = document.body;

        if (this.scrollbarWidth > 0) {
            body.style.paddingRight = `${this.scrollbarWidth}px`;
        }

        this.scrollPosition = window.scrollY || document.documentElement.scrollTop;
        body.classList.add('scroll-lock-active');

        body.style.position = 'fixed';
        body.style.top = `-${this.scrollPosition}px`;

        this.isLocked = true;
    }

    enableScroll () {
        if (!this.isLocked) return; // Nur wenn vorher gelockt wurde

        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.paddingRight = '';

        window.checkForScroll = false;
        window.scrollTo(0, this.scrollPosition);

        setTimeout(() => {
            window.checkForScroll = true;
        }, 500);

        document.body.classList.remove('scroll-lock-active');

        this.isLocked = false;
    }

    /* return the scrollbar width */
    getScrollbarWidth () {
        return window.innerWidth - document.documentElement.clientWidth;
    }
}

const scrollLock = new ScrollLock();
export default scrollLock;
